import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UtilsService} from '../core/utils/utils.service';

@Component({
  selector: 'app-acoes',
  templateUrl: './acoes.component.html'
})

export class AcoesComponent implements OnInit {
  empresaId;
  usuario = this._utils.getUsuario();
  title;
  tabs = [
    {nome: 'tabela', label: 'Tabela'},
    {nome: 'graficos', label: 'Gráficos'},
    {nome: 'lista-acoes', label: 'Lista de Ações'}];
  activeTab = 'tabela';
  loaded = true;

  constructor(private _activatedRoute: ActivatedRoute, private _utils: UtilsService) {
  }

  tabChange(tab) {
    this.activeTab = tab['nome'];
  }

  ngOnInit() {
    if ((window.location.pathname).includes('decisao')) {
      this.title = 'Decidir Plano de Ações';
      this.tabs.splice(1, 1);
    } else {
      this.title = 'Executar Plano de Ações';
    }

    this._activatedRoute.params.subscribe(params => {
      if (+params['empresaId']) {
        this.empresaId = +params['empresaId'];
      } else {
        this.empresaId = this.usuario.empresa;
      }
    });
  }

}
